// extracted by mini-css-extract-plugin
export default {"logoWrapper":"styles_logoWrapper__vMjNh","logoPrimaryWrapper":"styles_logoPrimaryWrapper__vs-oq"};